// extracted by mini-css-extract-plugin
export var pillWrapper = "_xn-0";
export var showOverflow = "_xn-1";